import axios from "axios";

const getAuthenticators = () => axios.get(`/personal/api/v1/webauthn/factors`);

const challenge = (challenge) => axios.post(`/personal/api/v1/webauthn/registration/challenge`, challenge);

const register = (data) => axios.post(`/personal/api/v1/webauthn/register`, data);

const reset = () => axios.delete(`/personal/api/v1/webauthn/reset`);

export default {
    getAuthenticators,
    challenge,
    register,
    reset
}